import {
  MembershipAdjustPointsMutationOptions,
  MembershipHomeStoresCreateOrUpdateMutationOptions,
  MembershipStateTransitionMutationOptions,
  MembershipUpdateMutationOptions,
  useMembershipAdjustPointsMutation,
  useMembershipHomeStoresCreateOrUpdateMutation as useApolloMembershipHomeStoresCreateOrUpdateMutation,
  useMembershipStateTransitionMutation,
  useMembershipUpdateMutation,
  useDeleteMembershipScrubDataMutation,
  useDeleteMembershipMutation,
  DeleteMembershipMutationOptions,
  DeleteMembershipScrubDataMutationOptions,
} from '@occc/graphql';

import { useMutation } from '../utils';

export const useUpdateMembership = (baseOptions: MembershipUpdateMutationOptions) =>
  useMutation(useMembershipUpdateMutation, baseOptions);

export const useMembershipHomeStoresCreateOrUpdateMutation = (
  baseOptions?: MembershipHomeStoresCreateOrUpdateMutationOptions,
) => useMutation(useApolloMembershipHomeStoresCreateOrUpdateMutation, baseOptions);

export const useMembershipAdjustPoints = (baseOptions?: MembershipAdjustPointsMutationOptions) =>
  useMutation(useMembershipAdjustPointsMutation, baseOptions);

export const useMembershipStateTransition = (
  baseOptions?: MembershipStateTransitionMutationOptions,
) => useMutation(useMembershipStateTransitionMutation, baseOptions);

export const useMembershipDelete = (baseOptions?: DeleteMembershipMutationOptions) => {
  return useMutation(useDeleteMembershipMutation, baseOptions);
};

export const useMembershipScrubData = (baseOptions?: DeleteMembershipScrubDataMutationOptions) => {
  return useMutation(useDeleteMembershipScrubDataMutation, baseOptions);
};
